<template>
  <BuyerOneColumnPage
    :title="title"
    subTitle="Anúncios não concretizados em compras"
    :icon="icon"
    :section="section"
    :description="description"
    :getContent="getAssessmentUnfufilled"
    labelCard="Sua última avaliação"
    buyerScope="UnfulilledPurchases"
    noVehicleLabel="Você ainda não avaliou nenhum veículo…"
    priceBackgroundColor="#F22300"
  />
</template>

<script>
import { BUYER_SECTION_CLOSED } from "@/views/buyer/constants/BuyerSections";

import PlatformsMixins from "@/mixins/PlatformsMixins";
import BuyerComponentPagesMixins from "@/mixins/BuyerComponentPagesMixins";

import { getAssessmentUnfufilled } from "@/services/api/BuyerServiceApi";

import BuyerOneColumnPage from "../../BuyerOneColumnPage";

export default {
  name: "AssessmentUnfulfilledPurchasesPage",
  mixins: [PlatformsMixins, BuyerComponentPagesMixins],
  components: { BuyerOneColumnPage },
  data: function () {
    return {
      ...BUYER_SECTION_CLOSED,
      title: "Não concretizadas - Avaliações superadas",
      section: "Encerrados",
    };
  },
  methods: {
    getAssessmentUnfufilled,
  },
};
</script>

<style scoped></style>
